import { useTranslation } from 'react-i18next'
import { useRef } from 'react'
import { LabelFormFields } from 'components/forms/LabelForm/types'
import { LabelForm } from 'components/forms/LabelForm/LabelForm'
import { Modal, ModalProps } from 'components/layout/Modal/Modal'
import * as Styled from './LabelModal.styles'

interface LabelModalProps extends Omit<ModalProps, 'children' | 'onClose'> {
  open: boolean
  labelId?: number
  initialValues?: LabelFormFields
  onClose: () => void
  onSave: (values: LabelFormFields, id?: number) => void
  isLoading?: boolean
  isError?: boolean
}

const LabelModal = ({
  open,
  labelId,
  initialValues,
  onClose: handleClose,
  onSave: handleSave,
  isLoading,
  isError,
}: LabelModalProps): JSX.Element => {
  const {
    t,
  } = useTranslation()

  const handleCloseModal = () => {
    handleClose()
  }

  const submitRef = useRef<() => void>(() => {})

  const isEdit = typeof labelId !== 'undefined'

  return (
    <Styled.Modal open={open} onClose={handleCloseModal}>
      <Modal.Title variant='h3'>{t(`labels.${isEdit ? 'edit' : 'new'}`)}</Modal.Title>
      <Styled.ModalContent>
        <LabelForm
          isEdit={isEdit}
          initialValues={initialValues}
          onSave={(values: LabelFormFields) => handleSave(values, labelId)}
          submitRef={submitRef}
        />
      </Styled.ModalContent>
      <Modal.Actions
        isLoading={isLoading}
        isSaveDisabled={isError}
        onCancel={handleCloseModal}
        onSave={() => submitRef.current()}
        confirmLabel={t(`common.${isEdit ? 'edit' : 'create'}`)}
      />
    </Styled.Modal>
  )
}

export { LabelModal }
